// extracted by mini-css-extract-plugin
export default {"appContainer":"jPr3TbmLNrQmy2LxTAjQ","appWithSidebarContainer":"STAjMsP8fZJW2GqdO2TU"};